import React from 'react';
import { connect } from 'react-redux';
import logo from '../../assets/image/logoblanco.png';
import facebook from '../../assets/image/facebook-white.svg';
import instagram from '../../assets/image/instagram-white.svg';
import tiktok from '../../assets/image/tiktok-white.svg';
import whatsapp from '../../assets/image/whatsapp.png';
import maps from '../../assets/image/maps-and-location.png';
import { Link } from 'react-router-dom';

function Footer({ }) {
    return (
        <footer className="p-4 bg-brand-blue sm:p-8 mt-10 shadow-inner">
            <div className="mx-auto max-w-screen-xl">

                <div className="row">
                    <div className="col-6 col-md-4 mb-8 md:mb-0">
                        <div className="flex justify-center">
                            <div className="flex flex-column">
                                <div className="flex items-center">
                                    <img src={logo} className="mr-3"
                                        alt="mioprecio" width={200} />
                                </div>
                                <div className="mt-2">
                                    <span
                                        className="self-center text-sm sm:text-base font-semibold text-white">Síguenos en redes socíales</span>
                                    <div className="flex gap-4 mt-4">
                                        <a href="https://www.facebook.com/" target="_blank" className="hover:scale-110 transition-transform duration-300">
                                            <img src={facebook} alt="Facebook" width={32} />
                                        </a>
                                        <a href="https://www.instagram.com/" target="_blank" className="hover:scale-110 transition-transform duration-300">
                                            <img src={instagram} alt="Instagram" width={32} />
                                        </a>
                                        <a href="https://www.tiktok.com/" target="_blank" className="hover:scale-110 transition-transform duration-300">
                                            <img src={tiktok} alt="TikTok" width={32} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 mb-8 md:mb-0">
                        <div className="flex justify-center">
                            <div className="flex flex-column">
                                <div className="flex items-center">
                                    <label className="self-center text-sm sm:text-base font-semibold text-white">
                                        Sobre nosotros
                                    </label>
                                </div>
                                <div className="mt-2">
                                    <ul className="pl-0 text-white text-sm space-y-2">
                                        <li>
                                            <Link to="/quienes-somos" className="hover:text-brand-orange transition-colors duration-300 no-underline text-white flex items-center gap-2">
                                                <span className="text-brand-orange text-lg">•</span> Quiénes somos
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/terminos-y-condiciones" className="hover:text-brand-orange transition-colors duration-300 no-underline text-white flex items-center gap-2">
                                                <span className="text-brand-orange text-lg">•</span> Términos y condiciones
                                            </Link>
                                        </li>


                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
                <div className="flex items-center justify-center">
                    <span className="text-sm sm:text-center text-white">
                        &copy; 2026 mioprecio.com Todos los derechos reservados.
                    </span>
                </div>
            </div>
        </footer>
    )
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Footer)